module.exports = __webpack_public_path__ + "img/Snickers.5f92d381.webp";